import { Box } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { LoginForm } from "@src/appV2/redesign/Login/LoginForm";
import { berlinRebrandTheme } from "@src/appV2/redesign/theme/theme";
import { useState } from "react";

interface EmailInputViewProps {
  emailInputError?: string;
  onSubmitEmail: (email: string) => void;
}

/**
 * Full-screen verify-email prompt rendered when the magic-link redeemer
 * can't resolve the requester email from cache. Self-wrapped so
 * AuthRedirectView can short-circuit to this without involving either
 * the legacy or redesigned view's render switch.
 *
 * Reuses the redesign LoginForm in its `verifyingEmail` mode (same UI
 * used by the legacy Firebase verify page).
 */
export function EmailInputView({ emailInputError, onSubmitEmail }: EmailInputViewProps) {
  const [email, setEmail] = useState("");

  return (
    <ThemeProvider theme={berlinRebrandTheme}>
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          zIndex: 1000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "background.baseDark",
          paddingX: 5,
          paddingTop: "max(24px, env(safe-area-inset-top))",
          paddingBottom: "max(24px, env(safe-area-inset-bottom))",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 420,
            paddingX: { xs: 5, sm: 7 },
            paddingY: 7,
            backgroundColor: "background.standout",
            borderRadius: (t) => t.borderRadius?.large,
            boxShadow: (t) => t.shadow?.card,
          }}
        >
          <LoginForm
            verifyingEmail
            email={email}
            loading={false}
            errorMessage={emailInputError}
            setEmail={setEmail}
            onSubmit={async () => {
              onSubmitEmail(email.trim());
            }}
          />
        </Box>
      </Box>
    </ThemeProvider>
  );
}
